import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'superAnnuation/FETCH_REQUEST'
const FETCH_SUCCESS = 'superAnnuation/FETCH_SUCCESS'
const FETCH_FAILURE = 'superAnnuation/FETCH_FAILURE'
const FETCH_FILTER_REQUEST = 'superAnnuation/FETCH_FILTER_REQUEST'
const FETCH_FILTER_SUCCESS = 'superAnnuation/FETCH_FILTER_SUCCESS'
const FETCH_FILTER_FAILURE = 'superAnnuation/FETCH_FILTER_FAILURE'
const DOWNLOAD_SUCCESS = 'superAnnuation/DOWNLOAD_SUCCESS'

const initialState = {
    result: { results: [], result: [] },
    loaded: false,
    loading: false,
    allResult: {},
    filterLoaded: false,
    filterLoading: false,
    errors: []
}

export function fetchRequest(payload = {}) {
    return {
        type: FETCH_REQUEST,
    }
}

export function fetchSuccess(payload) {
    return {
        type: FETCH_SUCCESS,
        payload,
    }
}

export function fetchFailure(errors = []) {
    return {
        type: FETCH_FAILURE,
        errors,
    }
}


export function fetchFilterRequest(payload = {}) {
    return {
        type: FETCH_FILTER_REQUEST,
    }
}

export function fetchFilterSuccess(payload) {
    return {
        type: FETCH_FILTER_SUCCESS,
        payload,
    }
}

export function downloadSuccess() {
    return {
        type: DOWNLOAD_SUCCESS
    }
}

export function fetchFilterFailure(errors = []) {
    return {
        type: FETCH_FILTER_FAILURE,
        errors,
    }
}

export function loadSuperannuationListData(options) {
    return (dispatch) => {
        dispatch(fetchRequest())

        const promise = api('api/v1/superannuation_funds/list', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }
                dispatch(fetchSuccess(json))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })
            })

        return promise
    }
}

export function loadSuperannuationListFilterData(options) {
    return (dispatch) => {
        dispatch(fetchFilterRequest())
        const promise = api('api/v1/superannuation_funds/list/', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                if (options['all']) {
                    dispatch(downloadSuccess())
                    toastr["success"](json['message']);
                } else {
                    dispatch(fetchFilterSuccess(json))
                }

            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFilterFailure(errors))    
                })
            })

        return promise
    }
}

export function loadExecutivesData(options) {
    return (dispatch) => {
        dispatch(fetchRequest())

        const promise = api('api/v1/superannuation_funds/executives', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }
                dispatch(fetchSuccess(json))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })
            })

        return promise
    }
}

export function loadExecutivesFilterData(options) {
    return (dispatch) => {
        dispatch(fetchFilterRequest())
        const promise = api('api/v1/superannuation_funds/executives/', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                if (options['all']) {
                    dispatch(downloadSuccess())
                    toastr["success"](json['message']);
                } else {
                    dispatch(fetchFilterSuccess(json))
                }

            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFilterFailure(errors))    
                })
            })

        return promise
    }
}
export function loadBoardCommitteesData(options) {
    return (dispatch) => {
        dispatch(fetchRequest())

        const promise = api('api/v1/superannuation_funds/board_committees', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(fetchSuccess(json))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })
            })

        return promise
    }
}

export function loadBoardCommitteesFilterData(options) {
    return (dispatch) => {
        dispatch(fetchFilterRequest())

        const promise = api('api/v1/superannuation_funds/board_committees/', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                if (options['all']) {
                    dispatch(downloadSuccess())
                    toastr["success"](json['message']);
                } else {
                    dispatch(fetchFilterSuccess(json))
                }
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFilterFailure(errors))
                })
            })

        return promise
    }
}
export function loadAllDirectorsData(options) {
    return (dispatch) => {
        dispatch(fetchRequest())

        const promise = api('api/v1/superannuation_funds/directors', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(fetchSuccess(json))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })
            })

        return promise
    }
}

export function loadAllDirectorsFilterData(options) {
    return (dispatch) => {
        dispatch(fetchFilterRequest())

        const promise = api('api/v1/superannuation_funds/directors/', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                if (options['all']) {
                    dispatch(downloadSuccess())
                    toastr["success"](json['message']);
                } else {
                    dispatch(fetchFilterSuccess(json))
                }
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })
            })

        return promise
    }
}

export function loadRemunerationListData(options) {
    return (dispatch) => {
        dispatch(fetchRequest())

        const promise = api('api/v1/superannuation_funds/remuneration', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }
                dispatch(fetchSuccess(json))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })
            })

        return promise
    }
}

export function loadRemunerationListFilterData(options) {
    return (dispatch) => {
        dispatch(fetchFilterRequest())
        const promise = api('api/v1/superannuation_funds/remuneration/', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                if (options['all']) {
                    dispatch(downloadSuccess())
                    toastr["success"](json['message']);
                } else {
                    dispatch(fetchFilterSuccess(json))
                }

            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFilterFailure(errors))    
                })
            })

        return promise
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const { payload, type, errors } = action

    switch (type) {
        case DOWNLOAD_SUCCESS:
            return Object.assign({}, state, {
                filterLoading: false,
                filterLoaded: true,
                errors: []
            })
        case FETCH_REQUEST:
            return Object.assign({}, state, {
                loading: true,
            })
        case FETCH_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                loaded: true,
                errors: [],
                result: payload
            })
        case FETCH_FAILURE:
            return Object.assign({}, state, {
                loaded: false,
                loading: false,
                errors,
            })
        case FETCH_FILTER_REQUEST:
            return Object.assign({}, state, {
                filterLoading: true,
            })
        case FETCH_FILTER_SUCCESS:
            return Object.assign({}, state, {
                filterLoading: false,
                filterLoaded: true,
                errors: [],
                result: payload
            })
        case FETCH_FILTER_FAILURE:
            return Object.assign({}, state, {
                filterLoaded: false,
                filterLoading: false,
                errors,
            })
        default:
            return state
    }
}

